import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import DownloadApplicationSection from "../Components/downloadApplicationSection";

const ContactUs = () => {
    return (
        <>
            <div style={{
                width: "100%",
                backgroundImage: "url('/ContactUsBg.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
            }} className="flex gap-5 px-4 md:px-8 py-8" >
                <p className="m-0 md:w-30rem" style={{ color: "#29345E", lineHeight: "4rem", textWrap: "wrap", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                    We Are Here For Your Questions.
                    <br />
                    <span style={{ color: "#E3506B" }}>Contact Us!</span>
                </p>
            </div>
            <div className="flex flex-wrap justify-content-between xl:justify-content-evenly align-items-center py-8 px-4 md:px-8 gap-6" style={{backgroundColor: "#F5F5F5"}}>
                <div className="flex flex-column justify-content-center align-items-start gap-6 flex-grow-1 xl:flex-grow-0 w-30rem" >
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >CONTACT</p>
                    <p className="m-0" style={{ color: "#2D3967", lineHeight: "3.5rem", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                        <span className="flex align-items-center gap-1">Mobithera<span style={{fontSize: "1rem", marginTop: "-0.5rem"}}>™</span></span> <span style={{ color: "#E3506B" }}>Corporation</span>
                    </p>
                    <p className="m-0 text-lg flex-grow-1" style={{ color: "#727A99", textWrap: "wrap" }} >
                        Figma ipsum component variant main layer. Effect figjam strikethrough strikethrough editor device edit. Rectangle strikethrough community style polygon layout frame ipsum editor editor.
                    </p>
                    <div className="flex flex-column font-bold text-lg gap-5 flex-grow-1" style={{ color: "#2D3967", textWrap: "wrap" }} >
                        <div className="flex gap-3 align-items-center">
                            <i className="pi pi-map-marker text-lg"></i>
                            <span className="" style={{ textWrap: "wrap" }}>
                                Gazi Üniversitesi Gölbaşı Yerleşkesi Bahçelievler Mah. 323/1 Cadde C Blok No: 10/50-C/109 Gölbaşı, Ankara/Türkiye
                            </span>
                        </div>
                        <div className="flex gap-3 align-items-center">
                            <i className="pi pi-phone text-lg"></i>
                            <span className="" style={{ textWrap: "wrap" }}>
                                +90 (530) 159 56 73
                            </span>
                        </div>
                        <div className="flex gap-3 align-items-center">
                            <i className="pi pi-at text-lg"></i>
                            <span className="" style={{ textWrap: "wrap" }}>
                                info@mobithera.com
                            </span>
                        </div>
                    </div>
                </div>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6132.425737929095!2d32.808112!3d39.779778!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d341448d13e2e9%3A0x958b1e7c1673b3ee!2sTiga%20Teknopark%20Ofis!5e0!3m2!1str!2sus!4v1753440488409!5m2!1str!2sus"
                    style={{ border: 0 }}
                    allowFullScreen
                    className="flex-grow-1 xl:flex-grow-0 w-30rem h-30rem"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
            <div className="flex flex-wrap justify-content-evenly align-items-center gap-5 px-4 md:px-8 py-8" style={{
                width: "100%",
                minHeight: "100vh",
                backgroundImage: "url('/ApplicationsImage.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            >
                <div className="flex flex-column gap-6 flex-grow-1 xl:flex-grow-0 xl:w-30rem">
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >CONTACT US</p>
                    <div>
                        <p className="m-0" style={{ color: "#2D3967", lineHeight: "3.25rem", fontSize: "3.25rem", fontWeight: 700 }} >
                            Connect <br /> <span style={{ color: "#E3506B" }}>with us</span>
                        </p>
                    </div>
                    <p className="m-0 text-lg" style={{ color: "#727A99", textWrap:"wrap" }} >
                        Whether you're a clinic, a therapist, or just exploring options. We're here to support your journey with answers, guidance, and care.
                    </p>
                    <div className="mb-4 md:mb-0 md:mt-8">
                        <p className="m-0" style={{ color: "#2D3967", fontSize: "1.75rem", fontWeight: 700 }} >Revolutionizing</p>
                        <p className="m-0" style={{ color: "#E3506B", fontSize: "1.75rem", fontWeight: 700  }} >Physical Therapy</p>
                    </div>
                </div>
                <div className="flex flex-column gap-4 w-30rem flex-grow-1 xl:flex-grow-0">
                    <div className="flex flex-column gap-1">
                        <label htmlFor="firstName" className="text-base" style={{ color: "#727A99" }}>First Name <span style={{ color: "#E3506B"}}>*</span></label>
                        <InputText id="firstName" className="" placeholder="Enter the First Name" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                    </div>
                    <div className="flex flex-column gap-1">
                        <label htmlFor="lastName" className="text-base" style={{ color: "#727A99" }}>Last Name <span style={{ color: "#E3506B"}}>*</span></label>
                        <InputText id="lastName" className="" placeholder="Enter the Last Name" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                    </div>
                    <div className="flex flex-column gap-1">
                        <label htmlFor="email" className="text-base" style={{ color: "#727A99" }}>E Mail <span style={{ color: "#E3506B"}}>*</span></label>
                        <InputText id="email" className="" placeholder="example@mail.com" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                    </div>
                    <div className="flex flex-column gap-1">
                        <label htmlFor="phone" className="text-base" style={{ color: "#727A99" }}>Phone Number <span style={{ color: "#E3506B"}}>*</span></label>
                        <InputText id="phone" className="" placeholder="xxx xxx xx xx" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                    </div>
                    <div className="flex flex-column gap-1">
                        <label htmlFor="message" className="text-base" style={{ color: "#727A99" }}>Message</label>
                        <InputTextarea id="message" className="" placeholder="Type for message here..." style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                    </div>
                    <Button className="flex justify-content-center align-items-center gap-1"
                        style={{
                            color: "white",
                            backgroundColor: "#E3506B",
                            borderRadius: "10px",
                            height: "2.5rem",
                            fontWeight: "bold"
                        }}>
                            Submit
                            <img src="/Check.png" width={20} />
                    </Button>
                </div>
            </div>
            <DownloadApplicationSection />
        </>
    )
}

export default ContactUs;